module.exports = __webpack_public_path__ + "img/DE02621.82e34857.png";